import { render, staticRenderFns } from "./FastFallTech.vue?vue&type=template&id=73c88a8f&"
import script from "./FastFallTech.vue?vue&type=script&lang=ts&"
export * from "./FastFallTech.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports